/* eslint-disable no-plusplus */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { Divider } from '@material-ui/core';

import DataTable from '~/components/DataTable';
import LocaleMessage from '~/components/LocaleMessage';
import CounterCard from '~/components/Reports/CounterCard';
import ExportCSVButton from '~/components/Reports/CSVButton';
import ReportDateChart from '~/components/Reports/ReportDateChart';
import ReportHeader from '~/components/Reports/ReportHeader';
import ReportPieChart from '~/components/Reports/ReportPieChart';
import ReportTimeChart from '~/components/Reports/ReportTimeChart';
import Splash from '~/components/Splash/Inside';

import api from '~/services/pluginbot-api';
import GetDateTimeLabel from '~/util/GetDateTimeLabel';
import GetFileName from '~/util/GetFileName';
import GetPeriodDates from '~/util/GetPeriodDates';
import lng_labels from '~/util/LangMessages';

import { TotalContainer, InfoContainer, TableArea } from './style';

const warnings = ['warnings.version.cruzr_v3110', 'warnings.version.temi_v260'];

export default function MissionReports({
    settings,
    headerSettings,
    requestError,
    counterData,
    language,
    options,
}) {
    const lng_all = lng_labels[language] || {};

    const {
        fromISO,
        untilISO,
        minDate,
        shortcuts,
        handleFromDateChange,
        handleUntilDateChange,
        handlePeriodShortcut,
    } = headerSettings;

    const { active, colors, format, locale, dateOptions, dark_mode } = settings;

    const mountedRef = React.useRef(true);
    const [isLoading, setIsLoading] = useState(true);
    const [rawLogData, setRawLogData] = useState({});
    const [actionLogList, setActionLogList] = useState([]);
    const [groupedData, setGroupedData] = useState({});
    const [singleObjFilter, setSingleObjFilter] = useState(null);

    const headers_file = [
        {
            key: 'created_date',
            label: 'Date',
        },
        {
            key: 'created_time',
            label: 'Time',
        },
        { key: 'group', label: 'Group' },
        { key: 'robot', label: 'Robot' },
        { key: 'application', label: 'Application' },
        { key: 'origin_label', label: 'Origin' },
        { key: 'created_by_operator', label: 'Operator' },
        { key: 'function_label', label: 'Action' },
        { key: 'function_details', label: 'Parameters' },
        { key: 'result_label', label: 'Result' },
        { key: 'canceled_by_operator', label: 'Canceled by' },
    ];

    const headers_table = [
        {
            id: 'created',
            order_by: 'timestamp',
            label: <LocaleMessage msg="table.headers.date" />,
        },
        {
            id: 'robot',
            label: <LocaleMessage msg="table.headers.robot" />,
        },
        {
            id: 'function_complete',
            label: <LocaleMessage msg="table.headers.action" />,
        },
        {
            id: 'function_details',
            label: '',
        },
        {
            id: 'result_label',
            label: (
                <LocaleMessage msg="page.reports.robot_missions.label.result" />
            ),
        },
    ];

    function getMissionContent(type, data) {
        switch (type) {
            case 'run_script': {
                const { script } = data;
                return script && script.id ? script.name : '';
            }
            case 'map_navigation': {
                const { map, point } = data;
                return map && map.id
                    ? `${map.name} - ${point && point.name ? point.name : '-'}`
                    : '';
            }
            case '':
            default:
                return '';
        }
    }

    function filterRawData(data) {
        const { groups, robots, robot_types, applications } = counterData;
        const { period, logs } = data;

        const a_groups = {};
        const a_applications = {};
        const a_robots = {};
        const a_r_types = {};
        const a_origins = {};
        const a_function_types = {};
        const a_date = {};
        const a_time = {};
        const a_acceptance = {
            accepted: {
                value: 0,
                name: lng_all[`page.reports.robot_missions.label.accepted`],
            },
            rejected: {
                value: 0,
                name: lng_all[`page.reports.robot_missions.label.rejected`],
            },
        };
        const a_results = {
            rejected: {
                value: 0,
                name: lng_all[`list.mission.status.not_executed`],
            },
        };

        const alist = logs.list.map(a => {
            const datetime = GetDateTimeLabel(new Date(a.created), { format });

            const group = groups[a.group_id];
            const application = applications[a.application_id];
            const robot = robots[a.robot_id];
            const origin = a.origin || 'unknown';
            const origin_label = lng_all[`list.mission.origin.${origin}`] || '';
            const action_type = a.action_type || '';
            const function_details = getMissionContent(
                action_type,
                a.content || {}
            );
            const function_label =
                lng_all[`list.mission.type.${action_type}`] || '';
            const function_complete = function_label
                ? `[${origin_label}] ${function_label}`
                : '';
            const result_key = a.status || '';
            const result_label =
                lng_all[`list.mission.status.${result_key}`] || '';
            let final_label = result_label;

            a_groups[a.group_id] = a_groups[a.group_id]
                ? a_groups[a.group_id] + 1
                : 1;

            a_applications[a.application_id] = a_applications[a.application_id]
                ? a_applications[a.application_id] + 1
                : 1;

            a_robots[a.robot_id] = a_robots[a.robot_id]
                ? a_robots[a.robot_id] + 1
                : 1;

            a_r_types[a.robottype_id || 'not_assigned'] = a_r_types[
                a.robottype_id || 'not_assigned'
            ]
                ? a_r_types[a.robottype_id || 'not_assigned'] + 1
                : 1;

            a_function_types[action_type] = a_function_types[action_type]
                ? {
                      ...a_function_types[action_type],
                      value: a_function_types[action_type].value + 1,
                  }
                : {
                      id: action_type,
                      name: function_label,
                      value: 1,
                  };

            a_origins[origin] = a_origins[origin]
                ? {
                      ...a_origins[origin],
                      value: a_origins[origin].value + 1,
                  }
                : {
                      id: a_origins,
                      name: origin_label,
                      value: 1,
                  };

            if (a.accepted) {
                a_acceptance.accepted = {
                    ...a_acceptance.accepted,
                    value: a_acceptance.accepted.value + 1,
                };

                a_results[result_key] = a_results[result_key]
                    ? {
                          ...a_results[result_key],
                          value: a_results[result_key].value + 1,
                      }
                    : {
                          id: result_key,
                          name: result_label,
                          value: 1,
                      };
            } else {
                a_acceptance.rejected = {
                    ...a_acceptance.rejected,
                    value: a_acceptance.rejected.value + 1,
                };

                a_results.rejected = {
                    ...a_results.rejected,
                    value: a_results.rejected.value + 1,
                };

                final_label = `${
                    lng_all[`list.mission.status.not_executed`]
                } (${result_label})`;
            }

            a_date[datetime.date] = a_date[datetime.date]
                ? a_date[datetime.date] + 1
                : 1;

            a_time[datetime.hour] = a_time[datetime.hour]
                ? a_time[datetime.hour] + 1
                : 1;

            const c_operator = a.created_by ? a.created_by.name : '';
            const u_operator = a.updated_by ? a.updated_by.name : '';

            return {
                ...a,
                group: group ? group.name : '---',
                application: application ? application.name : '---',
                robot: robot ? `[${robot.code}] ${robot.name}` : '---',
                origin,
                origin_label,
                function: action_type || '---',
                function_label,
                function_details,
                function_complete,
                result_key: result_key || '---',
                result_label: final_label,
                created_date: datetime.date,
                created_time: datetime.time,
                created: datetime.string,
                created_by_operator: a.appkey ? a.appkey.name : c_operator,
                canceled_by_operator:
                    result_key === 'canceled' ? u_operator : '',
                timestamp: datetime.timestamp,
            };
        });

        const not_assigned_label =
            lng_all[`page.reports.robot_missions.label.not_assigned`];

        const robot_grouped = Object.keys(a_robots).map(a => {
            const val = a_robots[a];
            const obj = robots[a];

            return {
                name: obj ? `[${obj.code}] ${obj.name}` : not_assigned_label,
                value: val,
            };
        });

        const application_grouped = Object.keys(a_applications).map(a => {
            const val = a_applications[a];
            const obj = applications[a];

            return {
                name: obj ? obj.name : '---',
                value: val,
            };
        });

        const group_grouped = Object.keys(a_groups).map(g => {
            const val = a_groups[g];
            const obj = groups[g];

            return {
                name: obj ? obj.name : '---',
                value: val,
            };
        });

        const rtype_grouped = Object.keys(a_r_types).map(t => {
            const val = a_r_types[t];
            const obj = robot_types[t];

            return {
                name: obj ? obj.name : not_assigned_label,
                value: val,
            };
        });

        const origin_grouped = Object.keys(a_origins).map(a => {
            return a_origins[a] || {};
        });

        const function_grouped = Object.keys(a_function_types).map(a => {
            return a_function_types[a] || {};
        });

        const acceptance_grouped = Object.keys(a_acceptance).map(a => {
            return a_acceptance[a] || {};
        });

        const result_grouped = Object.keys(a_results).map(a => {
            return a_results[a] || {};
        });

        const period_dates = GetPeriodDates(period);

        const d_labels = [];
        const date_grouped = [];
        period_dates.forEach(p => {
            const formatted_date = new Date(p).toLocaleDateString(
                format.format,
                dateOptions
            );
            const label_date = new Date(p).toLocaleDateString(format.format, {
                month: '2-digit',
                day: '2-digit',
            });
            d_labels.push(label_date);
            date_grouped.push({
                date: label_date,
                value: a_date[formatted_date] || 0,
            });
        });

        const t_labels = [];
        const time_grouped = [];
        for (let t = 0; t < 24; t++) {
            const label_time = t < 10 ? `0${t}h` : `${t}h`;
            t_labels.push(label_time);
            time_grouped.push({
                hour: label_time,
                value: a_time[t] || 0,
            });
        }

        setGroupedData({
            groups: group_grouped,
            robots: robot_grouped,
            robot_types: rtype_grouped,
            applications: application_grouped,
            origins: origin_grouped,
            functions: function_grouped,
            acceptance: acceptance_grouped,
            results: result_grouped,
            date: date_grouped,
            time: time_grouped,
            d_labels,
            t_labels,
        });

        setActionLogList(alist);
    }

    async function loadData() {
        setIsLoading(true);
        let query_filters = ``;
        if (options && options.application) {
            query_filters += `&application_id=${options.application}`;
        }
        if (options && options.robot) {
            query_filters += `&robot_id=${options.robot}`;
        }

        await api
            .get(
                `reports/robot_missions?from=${fromISO}&until=${untilISO}${query_filters}`
            )
            .then(response => {
                const { data } = response;
                filterRawData(data);
                setRawLogData(data.logs);
                setSingleObjFilter(data.appkey || null);
                setIsLoading(false);
            })
            .catch(error => requestError(error));
    }

    useEffect(() => {
        if (mountedRef.current) {
            loadData();
        }
    }, [settings, fromISO, untilISO, locale]);

    useEffect(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);

    function CSVButton() {
        return (
            <ExportCSVButton
                data={actionLogList}
                headers={headers_file}
                filename={GetFileName(`REPORT-robot_missions`, 'csv')}
            />
        );
    }

    function buildDateChart(title, data, key = 'value') {
        return (
            <ReportDateChart
                title={title}
                color={colors.dashboard_graphs}
                data={data}
                labels={groupedData.d_labels}
                dataKey={key}
            />
        );
    }

    function buildHourChart(title, data, key = 'value') {
        return (
            <ReportTimeChart
                title={title}
                color={colors.dashboard_cards}
                data={data}
                labels={groupedData.d_labels}
                dataKey={key}
            />
        );
    }

    const show_group_card = active && active.id === '*';
    const def_class = `col-md-4 col-12 mb-5`;

    const pie_charts = [
        ...(show_group_card
            ? [
                  {
                      key: 'groups',
                      title: 'per_group',
                      color: colors.dashboard_graphs,
                      data: groupedData.groups,
                  },
              ]
            : []),
        {
            key: 'robots',
            title: 'per_robot',
            color: colors.dashboard_cards,
            data: groupedData.robots,
        },
        {
            key: 'robot_types',
            title: 'per_robot_type',
            color: colors.dashboard_graphs,
            data: groupedData.robot_types,
        },
        {
            key: 'applications',
            title: 'per_application',
            color: colors.dashboard_cards,
            data: groupedData.applications,
        },
        {
            key: 'functions',
            title: 'per_function_type',
            color: colors.dashboard_graphs,
            data: groupedData.functions,
        },
        {
            key: 'origins',
            title: 'per_origin',
            color: colors.dashboard_cards,
            data: groupedData.origins,
        },
        {
            key: 'acceptance',
            title: 'per_acceptance',
            color: colors.dashboard_graphs,
            data: groupedData.acceptance,
        },
        {
            key: 'results',
            title: 'per_result',
            color: colors.dashboard_cards,
            data: groupedData.results,
        },
    ];

    return (
        <>
            <ReportHeader
                date_props={{
                    locale,
                }}
                period={{
                    minDate,
                    fromDate: new Date(fromISO),
                    untilDate: new Date(untilISO),
                }}
                handleFromDateChange={handleFromDateChange}
                handleUntilDateChange={handleUntilDateChange}
                reloadData={() => loadData()}
                exportButton={CSVButton()}
                shortcuts={shortcuts}
                handleShortcutClick={_id => handlePeriodShortcut(_id)}
            />
            <div className="sidecard-body mt-3">
                {isLoading ? (
                    <Splash />
                ) : (
                    <>
                        {warnings.length > 0 ? (
                            <div className="col-12 mt-3 mb-3">
                                {warnings.map(w => {
                                    return (
                                        <p key={`label_${w}`}>
                                            <LocaleMessage msg={w} />
                                        </p>
                                    );
                                })}
                            </div>
                        ) : null}
                        {singleObjFilter ? (
                            <>
                                <Divider />
                                <TotalContainer className="mt-3">
                                    <div className="mt-3 mb-3">
                                        <p
                                            className="card-title"
                                            style={{
                                                textTransform: 'uppercase',
                                            }}
                                        >
                                            {singleObjFilter.name}
                                        </p>
                                    </div>
                                </TotalContainer>
                            </>
                        ) : null}
                        <Divider />
                        <TotalContainer className="mt-3 mb-5">
                            <CounterCard
                                classes="col-md-4 col-12"
                                title={
                                    <LocaleMessage msg="page.reports.robot_missions.label.total" />
                                }
                                value={rawLogData.total || '0'}
                            />
                        </TotalContainer>
                        <Divider />
                        <InfoContainer className="row mt-3 mb-3">
                            {pie_charts.map(c => {
                                const datakey = 'value';
                                return (
                                    <ReportPieChart
                                        key={`${datakey}_${c.key}`}
                                        classes={def_class}
                                        title={
                                            <LocaleMessage
                                                msg={`page.reports.robot_missions.label.${c.title}`}
                                            />
                                        }
                                        color={c.color}
                                        data={c.data}
                                        dataKey={datakey}
                                        customization={{
                                            stroke: dark_mode
                                                ? '#424242'
                                                : '#ddd',
                                        }}
                                    />
                                );
                            })}
                        </InfoContainer>
                        <Divider />
                        <div className="row mt-3 mb-3">
                            {buildDateChart(
                                <LocaleMessage msg="page.reports.robot_missions.label.per_date" />,
                                groupedData.date
                            )}
                            {buildHourChart(
                                <LocaleMessage msg="page.reports.robot_missions.label.per_hour" />,
                                groupedData.time
                            )}
                        </div>
                        <Divider />
                        <InfoContainer className="row mt-3 mb-3">
                            <TableArea className="col-12 mb-3 table-responsive-material">
                                <div className="mt-3 mb-3">
                                    <p className="card-title">
                                        <LocaleMessage msg="page.reports.robot_missions.label.history" />
                                    </p>
                                </div>
                                <DataTable
                                    maxHeight="100%"
                                    headerColumns={headers_table}
                                    data={actionLogList || []}
                                    orderDirection="desc"
                                    orderColumn="timestamp"
                                    hasActions={false}
                                    handleTableRowClick={() => {}}
                                    defaultRowsPerPage={25}
                                    sortable
                                />
                            </TableArea>
                        </InfoContainer>
                    </>
                )}
            </div>
        </>
    );
}

MissionReports.defaultProps = {
    language: '',
};

MissionReports.propTypes = {
    settings: PropTypes.object.isRequired,
    headerSettings: PropTypes.object.isRequired,
    requestError: PropTypes.func.isRequired,
    counterData: PropTypes.object.isRequired,
    language: PropTypes.string,
};
